const ALLOWED_DOMAINS = new Set([
    "gmail.com",
    "yahoo.com",
    "yahoo.com.mx",
    "outlook.com",
    "hotmail.com",
    "icloud.com",
]);

export const isAllowedEmail = (email) => {
    if (!email || !email.includes('@')) return false;
    const domain = email.split('@')[1].toLowerCase();
    return ALLOWED_DOMAINS.has(domain);
};

export const isPlusAddressing = (email) => {
    if (!email || !email.includes('@')) return false;
    const localPart = email.split('@')[0];
    return localPart.includes('+');
};

export const temporaryEmailRule = {
    validator(_, value) {
        if (value && !isAllowedEmail(value)) {
            return Promise.reject(new Error('Solo se permiten correos de Gmail, Yahoo, Outlook, Hotmail o iCloud.'));
        }
        if (value && isPlusAddressing(value)) {
            return Promise.reject(new Error('No se permiten correos con alias (+).'));
        }
        return Promise.resolve();
    },
};
